import React, { useState } from "react";
import { loginUser } from "./services/auth";

function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    await new Promise(r => setTimeout(r, 600)); // simulate async
    if (loginUser(username, password)) {
      onLogin();
    } else {
      setError("Invalid credentials. Try admin / admin123");
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #0f172a 100%)",
      fontFamily: "'Inter', 'Segoe UI', sans-serif",
      position: "relative",
      overflow: "hidden",
    }}>
      {/* Background decorative orbs */}
      <div style={{
        position: "absolute", top: "-15%", left: "-10%",
        width: "600px", height: "600px", borderRadius: "50%",
        background: "radial-gradient(circle, rgba(59,130,246,0.15) 0%, transparent 70%)",
        pointerEvents: "none",
      }} />
      <div style={{
        position: "absolute", bottom: "-15%", right: "-10%",
        width: "500px", height: "500px", borderRadius: "50%",
        background: "radial-gradient(circle, rgba(99,102,241,0.15) 0%, transparent 70%)",
        pointerEvents: "none",
      }} />
      <div style={{
        position: "absolute", top: "30%", right: "15%",
        width: "300px", height: "300px", borderRadius: "50%",
        background: "radial-gradient(circle, rgba(16,185,129,0.08) 0%, transparent 70%)",
        pointerEvents: "none",
      }} />

      {/* Grid pattern overlay */}
      <div style={{
        position: "absolute", inset: 0,
        backgroundImage: `linear-gradient(rgba(59,130,246,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(59,130,246,0.04) 1px, transparent 1px)`,
        backgroundSize: "40px 40px",
        pointerEvents: "none",
      }} />

      {/* Card */}
      <div style={{
        width: "420px",
        background: "rgba(15, 25, 50, 0.85)",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        border: "1px solid rgba(59,130,246,0.2)",
        borderRadius: "20px",
        boxShadow: "0 25px 60px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.04), inset 0 1px 0 rgba(255,255,255,0.06)",
        padding: "44px 40px",
        position: "relative",
        zIndex: 1,
      }}>

        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <div style={{
            width: "64px", height: "64px", borderRadius: "16px",
            background: "linear-gradient(135deg, #2563eb, #3b82f6)",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: "28px", margin: "0 auto 16px",
            boxShadow: "0 0 30px rgba(59,130,246,0.4)",
          }}>
            📊
          </div>
          <h1 style={{
            margin: 0, fontSize: "22px", fontWeight: "700",
            color: "#f1f5f9", letterSpacing: "-0.02em",
          }}>
            AG‑Finance Portal
          </h1>
          <p style={{ margin: "6px 0 0", fontSize: "13px", color: "rgba(148,163,184,0.8)" }}>
            Advanced Spreadsheet & Analytics Engine
          </p>
        </div>

        {/* Feature pills */}
        <div style={{ display: "flex", justifyContent: "center", gap: "8px", marginBottom: "28px", flexWrap: "wrap" }}>
          {["📈 50 Rows", "🔒 Column Freeze", "fx Formula Bar", "📋 Multi-Sheet"].map(f => (
            <span key={f} style={{
              padding: "3px 10px", borderRadius: "20px", fontSize: "10.5px", fontWeight: "500",
              background: "rgba(59,130,246,0.12)", color: "#93c5fd",
              border: "1px solid rgba(59,130,246,0.2)",
            }}>{f}</span>
          ))}
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
          {/* Username */}
          <div>
            <label style={{ display: "block", fontSize: "11.5px", fontWeight: "600", color: "#94a3b8", marginBottom: "6px", letterSpacing: "0.06em", textTransform: "uppercase" }}>
              Username
            </label>
            <div style={{ position: "relative" }}>
              <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", fontSize: "14px", color: "#64748b", pointerEvents: "none" }}>👤</span>
              <input
                type="text"
                value={username}
                onChange={e => setUsername(e.target.value)}
                placeholder="Enter username"
                autoComplete="username"
                style={{
                  width: "100%", boxSizing: "border-box",
                  padding: "11px 14px 11px 38px",
                  background: "rgba(255,255,255,0.05)",
                  border: "1px solid rgba(100,116,139,0.3)",
                  borderRadius: "10px", outline: "none",
                  fontSize: "13.5px", color: "#e2e8f0",
                  transition: "border 0.2s, box-shadow 0.2s",
                }}
                onFocus={e => { e.target.style.border = "1px solid rgba(59,130,246,0.6)"; e.target.style.boxShadow = "0 0 0 3px rgba(59,130,246,0.12)"; }}
                onBlur={e => { e.target.style.border = "1px solid rgba(100,116,139,0.3)"; e.target.style.boxShadow = "none"; }}
              />
            </div>
          </div>

          {/* Password */}
          <div>
            <label style={{ display: "block", fontSize: "11.5px", fontWeight: "600", color: "#94a3b8", marginBottom: "6px", letterSpacing: "0.06em", textTransform: "uppercase" }}>
              Password
            </label>
            <div style={{ position: "relative" }}>
              <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", fontSize: "14px", color: "#64748b", pointerEvents: "none" }}>🔑</span>
              <input
                type={showPass ? "text" : "password"}
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Enter password"
                autoComplete="current-password"
                style={{
                  width: "100%", boxSizing: "border-box",
                  padding: "11px 40px 11px 38px",
                  background: "rgba(255,255,255,0.05)",
                  border: "1px solid rgba(100,116,139,0.3)",
                  borderRadius: "10px", outline: "none",
                  fontSize: "13.5px", color: "#e2e8f0",
                  transition: "border 0.2s, box-shadow 0.2s",
                }}
                onFocus={e => { e.target.style.border = "1px solid rgba(59,130,246,0.6)"; e.target.style.boxShadow = "0 0 0 3px rgba(59,130,246,0.12)"; }}
                onBlur={e => { e.target.style.border = "1px solid rgba(100,116,139,0.3)"; e.target.style.boxShadow = "none"; }}
              />
              <button type="button" onClick={() => setShowPass(v => !v)}
                style={{
                  position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)",
                  background: "none", border: "none", cursor: "pointer", color: "#64748b", fontSize: "14px", lineHeight: 1,
                }}>
                {showPass ? "🙈" : "👁"}
              </button>
            </div>
          </div>

          {/* Error */}
          {error && (
            <div style={{
              padding: "9px 12px", borderRadius: "8px",
              background: "rgba(239,68,68,0.1)", border: "1px solid rgba(239,68,68,0.25)",
              color: "#fca5a5", fontSize: "12.5px", display: "flex", gap: "6px", alignItems: "center",
            }}>
              <span>⚠️</span> {error}
            </div>
          )}

          {/* Submit */}
          <button type="submit" disabled={loading}
            style={{
              padding: "12px",
              background: loading ? "rgba(59,130,246,0.4)" : "linear-gradient(135deg, #2563eb, #3b82f6)",
              color: "#fff", border: "none", borderRadius: "10px",
              fontSize: "14px", fontWeight: "700", cursor: loading ? "not-allowed" : "pointer",
              transition: "transform 0.15s, box-shadow 0.15s",
              boxShadow: "0 4px 15px rgba(59,130,246,0.3)",
              display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
              marginTop: "4px",
            }}
            onMouseEnter={e => { if (!loading) { e.currentTarget.style.transform = "translateY(-1px)"; e.currentTarget.style.boxShadow = "0 6px 20px rgba(59,130,246,0.45)"; } }}
            onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 4px 15px rgba(59,130,246,0.3)"; }}
          >
            {loading ? (
              <>
                <span style={{ display: "inline-block", width: "14px", height: "14px", border: "2px solid rgba(255,255,255,0.4)", borderTopColor: "#fff", borderRadius: "50%", animation: "spin 0.6s linear infinite" }} />
                Signing in…
              </>
            ) : "Sign In →"}
          </button>
        </form>

        {/* Hint */}
        <div style={{
          marginTop: "20px", padding: "10px 14px", borderRadius: "8px",
          background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.06)",
          fontSize: "11.5px", color: "#64748b", textAlign: "center", lineHeight: 1.6,
        }}>
          Demo credentials: <span style={{ color: "#93c5fd", fontWeight: "600" }}>admin</span> / <span style={{ color: "#93c5fd", fontWeight: "600" }}>admin123</span>
        </div>

        {/* Version */}
        <div style={{ marginTop: "16px", textAlign: "center", fontSize: "10px", color: "#334155" }}>
          AG-Finance Portal v2.0 • Powered by AG-Grid React
        </div>
      </div>

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        input::placeholder { color: rgba(100,116,139,0.7); }
      `}</style>
    </div>
  );
}

export default Login;